/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';

const Pages = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const isSelect = location.state;



    const hideFooter = location.pathname.startsWith("/dashbord");

    const { ApiBaseUrl } = useContext(MyContext);

    const Perams = useParams();
    const Title = Perams.title?.replaceAll('_', ' ');

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    const LoadingStyle = isSelect ? "fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" : "h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white";

    useEffect(() => {
        axios.post(`${ApiBaseUrl}/customer/pages`)
            .then((res) => {
                // console.log("/customer/pages", res);
                if (res.data.ResponseCode === 200) {
                    setLoading(false);
                    setList(res.data.pages_data);
                }
            })
            .catch((error) => {
                console.error("pagelist.php", error);
            });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [Title]);

    return (
        <div className='content-wrapper'>
            {false ? <Loading CustomeStyle={LoadingStyle} index={0} />
                : <div className={!hideFooter && "width-container"}>
                    {
                        list?.map((item, index) => {
                            if (item.title.toLowerCase() === Title.toLowerCase()) {
                                return (
                                    <div key={index}>
                                        <h3 className='text-[20px] font-[500]'>{item.title}</h3>
                                        <p className='p-[20px]' dangerouslySetInnerHTML={{ __html: item?.description }} />
                                    </div>
                                );
                            }
                            return null;
                        })
                    }
                </div>}
        </div>
    )
}

export default Pages
/* jshint ignore:end */